module.exports = __webpack_public_path__ + "static/media/icon_usdt_color.7e6ee94d.svg";